import { createAction, props } from '@ngrx/store';
import { InAppNotificationPreference } from 'src/app/in-app-notifications/models/in-app-notification-preference.model';

export const getInAppNotificationPreferences = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Get In-App Notification Preferences'
);
export const getInAppNotificationPreferencesSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Get In-App Notification Preferences Success',
    props<{ inAppNotificationPreferences: InAppNotificationPreference[] }>()
);
export const getInAppNotificationPreferencesFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Get In-App Notification Preferences Failure',
    props<{ error: string }>()
);

export const updateInAppNotificationPreference = createAction(
    '[IN-APP NOTIFICATIONS LIST COMPONENT] Update In-App Notification Preference',
    props<{ preferenceId: number; isEnabled: boolean }>()
);
export const updateInAppNotificationPreferenceSuccess = createAction(
    '[IN-APP NOTIFICATIONS API] Update In-App Notification Preference Success',
    props<{ message: string }>()
);
export const updateInAppNotificationPreferenceFailure = createAction(
    '[IN-APP NOTIFICATIONS API] Update In-App Notification Preference Failure',
    props<{ error: string }>()
);
